import { z } from 'zod';
/**
 * Skill `document-mail-out` (Paket I, Issue #96).
 *
 * SMTP-Versand bereits generierter Dokumente (GeneratedDocument-Eintraege).
 * Mehrfach-Empfänger erlaubt (max 10 — defensiv gegen Spam-Missbrauch).
 */
export const sendDocumentMailRequest = z
    .object({
    to: z.array(z.string().email()).min(1).max(10),
    subject: z.string().min(1).max(200),
    body: z.string().min(1).max(5000),
    /**
     * Optionaler Behördenvorgang. Ist er gesetzt, wird der Versand als
     * ausgehende Korrespondenz am Vorgang festgehalten — sonst weiß später
     * niemand mehr, wann was an wen rausgegangen ist.
     */
    vorgangId: z.number().int().positive().optional(),
})
    .strict();
